import React from 'react';
import styled from 'styled-components';

const ReceivingHolds = () => {
  return (
    <MainContainer>
      <form>
        <SubTitle>
          <div>Hold found:</div>
          <a href="#">'Twixt Land and Sea : (000055)</a>
        </SubTitle>
        <WhiteBox>
          <Strong>Hold for:</Strong>
          <p>Burton, Mary (23529000651225) - Patron</p>
          <p>8131 Library Rd.</p>
          <p>Santa Cruz, CA 21234</p>
          <p>(212) 555-1212</p>
        </WhiteBox>
        <WhiteBox>
          <Strong>Transfer to:</Strong> Centerville
        </WhiteBox>
        <WhiteBox>
          <Strong>Reason for transfer:</Strong> Hold
        </WhiteBox>
        <WhiteBox>
          <Strong>Check in message</Strong>
          <p><a href="#">000055: 'Twixt Land and Sea :</a></p>
          <NotCheckedOut>Not checked out.</NotCheckedOut>
        </WhiteBox>
        <Actions>
          <Button type="submit">Confirm hold and transfer (Y)</Button>
          <Button type="button">Print slip, transfer, and confirm (P)</Button>
          <Button type="button">Ignore (I)</Button>
        </Actions>
      </form>
    </MainContainer>
  );
}

const MainContainer = styled.div`
  font-family: Arial, sans-serif;
  text-align: left;
  padding: 20px;
`;

const SubTitle = styled.div`
  text-align: left;
  font-size: 1.2em;
  font-weight: 600;
`;

const WhiteBox = styled.div`
  background-color: #fff;
  padding: 1em;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    padding: 0.5em;
  }
`;

const Strong = styled.p`
  font-weight: bold;
`;

const NotCheckedOut = styled.p`
  color: red;
`;

const Actions = styled.div`
  margin-top: 10px;

  button {
    margin-right: 10px;
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:nth-child(1) {
      background-color: #28a745;
      color: white;
    }

    &:nth-child(2) {
      background-color: #007bff;
      color: white;
    }

    &:nth-child(3) {
      background-color: #dc3545;
      color: white;
    }
  }
`;

const Button = styled.button`
  margin-right: 10px;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:nth-child(1) {
    background-color: #28a745;
    color: white;
  }

  &:nth-child(2) {
    background-color: #007bff;
    color: white;
  }

  &:nth-child(3) {
    background-color: #dc3545;
    color: white;
  }
`;

export default ReceivingHolds;
